import { render, staticRenderFns } from "./periphery.vue?vue&type=template&id=4093b63c&"
import script from "./periphery.vue?vue&type=script&lang=js&"
export * from "./periphery.vue?vue&type=script&lang=js&"
import style0 from "./periphery.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!C:\\Users\\86177\\AppData\\Roaming\\npm\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports